import { ActionIcon, Group, Tooltip } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"
import {
  certificateByOrganizationCertificateRequestDtoStatusEnum,
  certificateByOrganizationDtoStatusEnum,
} from "~/gen/api"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { type FindProductsProductStandardCertificateDto } from "~/gen/api"
import { CertificateRequestStatusBadge } from "~/pages/Brand/Certificates/components/CertificateRequestStatusBadge"
import { CertificateStatusBadge } from "~/pages/Brand/Certificates/components/CertificateStatusBadge"

type Props = {
  certificateRequest: FindProductsProductStandardCertificateDto
}

export const CertificateRequestLifecycleBadge = ({
  certificateRequest,
}: Props) => {
  const { t } = useTranslation("certificates")
  const shouldDisplayRequestStatusReviewLink =
    certificateRequest.certificateRequestStatus ===
      certificateByOrganizationCertificateRequestDtoStatusEnum.SUBMITTED &&
    certificateRequest.certificateId
  const shouldDisplayCertificateStatusReviewLink =
    certificateRequest.status !==
      certificateByOrganizationDtoStatusEnum.PROCESSED &&
    certificateRequest.certificateId
  const shouldDisplayCertificateStatusBadge =
    certificateRequest.certificateRequestStatus !==
    certificateByOrganizationCertificateRequestDtoStatusEnum.OPENED

  const reviewLink = certificateRequest.certificateId ? (
    <Tooltip label={t("standard.drawer.reviewCertificate")}>
      <ActionIcon
        component={Link}
        to={`/documents?certificateId=${certificateRequest.certificateId}`}
        target="_blank"
        rel="noopener noreferrer"
        variant="transparent"
        c="currentColor"
        size="xs"
        aria-label={t("standard.drawer.reviewCertificate")}
      >
        <IconExternalLink size={12} />
      </ActionIcon>
    </Tooltip>
  ) : null

  return (
    <Group gap="xs">
      <CertificateRequestStatusBadge
        certificateRequestStatus={certificateRequest.certificateRequestStatus}
        rightSection={shouldDisplayRequestStatusReviewLink ? reviewLink : null}
        userType="brand"
        displayMode="lifecycle"
      />
      {shouldDisplayCertificateStatusBadge ? (
        <CertificateStatusBadge
          status={certificateRequest.status}
          rightSection={
            shouldDisplayCertificateStatusReviewLink ? reviewLink : null
          }
          displayMode="lifecycle"
        />
      ) : null}
    </Group>
  )
}
